/**
 * @fileoverview Action type constants for groups.
 */
export const ADD_GROUP = "groups/ADD_GROUP";
export const EDIT_GROUP = "groups/EDIT_GROUP";
export const REMOVE_GROUP = "groups/REMOVE_GROUP";
export const TOGGLE_GROUP_VISIBILITY = "groups/TOGGLE_GROUP_VISIBILITY";
export const MOVE_GROUP_UP = "groups/MOVE_GROUP_UP";
export const MOVE_GROUP_DOWN = "groups/MOVE_GROUP_DOWN";
export const LOAD_STATE = "LOAD_STATE";
